"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Visibility_1 = require("../../lib/constants/Visibility");
const getInitialContext = () => ({
    appointmentWaitlistId: '',
    services: {
        getWaitlistDetails: () => Promise.resolve({}),
        getProvider: () => Promise.resolve({})
    },
    provider: undefined,
    customerCode: '',
    waitlist: undefined,
    loadingMachine: undefined,
    dobConfirmationMachine: undefined,
    config: {},
    validatedDateOfBirth: undefined,
    apptTimeMachine: undefined,
    jumpedToDate: undefined,
    filterBy: {
        dayOfWeek: new Set(),
        timeOfDay: new Set()
    },
    productName: undefined,
    apiBaseURL: undefined,
    visibility: {
        role: Visibility_1.CONSUMER_ROLE,
        schedulingVisibility: Visibility_1.SCHEDULING_VISIBILITY_CONSUMER,
        isVisibilityAgent: false
    },
    appointmentQuery: {}
});
exports.default = getInitialContext;
//# sourceMappingURL=getInitialContext.js.map